import { render, staticRenderFns } from "./DiseaseAndAccidentalBenefit.vue?vue&type=template&id=fb32f29a"
import script from "./DiseaseAndAccidentalBenefit.vue?vue&type=script&lang=js"
export * from "./DiseaseAndAccidentalBenefit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports